import { render } from "./enrolled-dependent-warning.vue?vue&type=template&id=616e3870&scoped=true"
import script from "./enrolled-dependent-warning.vue?vue&type=script&lang=js"
export * from "./enrolled-dependent-warning.vue?vue&type=script&lang=js"

import "./enrolled-dependent-warning.vue?vue&type=style&index=0&id=616e3870&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-616e3870"]])

export default __exports__